import LoginPage from '../pages/login.f7.html';
// import SplashPage from "../pages/splash.f7.html";
import HomePage from '../pages/home.f7.html';
import DashboardPage from '../pages/dashboard.f7.html';
import DashboardPageKeeper from '../pages/dashboardKeeper.f7.html';

import ActivitiesPage from '../pages/reservations-calendar.f7.html';
import MessagesPage from '../pages/messages.f7.html';
import ActivitySettingsPage from '../pages/activity-settings.f7.html';
import CancellationPage from '../pages/cancellations.f7.html';
import ReservationsSubPage from '../pages/reservations-in-activity.f7.html';

/*Avaliability tab*/
import AvailabilitiesPage from '../pages/availabilities-rates.f7.html';
import SetupRoomAvailabilityPage from '../pages/setup-room-availability.f7.html';
import PriceAndLimitsPage from '../pages/price-and-limits.f7.html';
/* End Avaliability tab*/

/*New Reservation*/
//import NewReservationPage from '../pages/new-reservation-home.f7.html';
import NewReservationPage from '../pages/new-reservation-form.f7.html';
import BlockInfo from '../pages/block-info.f7.html';
import NewReservationStayDetailsPage from '../pages/new-reservation-staydetails.f7.html';
import NewReservationCompletePage from '../pages/new-reservation-complete.f7.html';
//Plano
import ReservationsCalendar from '../pages/reservations-calendar.f7.html';

import ReservationsInfo from '../pages/reservation-info.f7.html';
import SelectedReservation from '../pages/search-reservation.f7.html';
import SearchUser from '../pages/search-user.f7.html';
import SearchArrivals from '../pages/search-arrivals.f7.html';
import SearchDepartures from '../pages/search-departures.f7.html';
import SearchInHouse from '../pages/search-inhouse.f7.html';

import PmsPage from '../pages/pms.f7.html';

import AboutPage from '../pages/about.f7.html';
import FormPage from '../pages/form.f7.html';
import CatalogPage from '../pages/catalog.f7.html';
import ProductPage from '../pages/product.f7.html';
import SettingsPage from '../pages/settings.f7.html';
import Communicator from '../pages/communicator.f7.html';
import InvoicesPage from '../pages/invoices.f7.html';
import SettingsNotifiationsPage from '../pages/settings-notifications.f7.html';

import ForgotPasswordPage from '../pages/forgot-password.f7.html';
import DynamicRoutePage from '../pages/dynamic-route.f7.html';
import RequestAndLoad from '../pages/request-and-load.f7.html';
import NotFoundPage from '../pages/404.f7.html';

import RoomStatusPage from '../pages/room-status.f7.html';
import { config } from 'reword-js';
import dictionary from '../js/translation.js';
import actions from '../js/actions.js';

import ArrivalsList from '../pages/arrivals-list.f7.html';
import DeparturesList from '../pages/departures-list.f7.html';
import InhouseList from '../pages/inhouse-list.f7.html';
import NotificationsPage from '../pages/notifications.f7.html';
import Test from '../pages/test.f7.html';
import ReservationsCalendarPage from '../pages/reservationspage.f7.html';
import DoNotDisturbPage from '../pages/donotdisturb.f7.html';
import SettingPlan from '../pages/settings-plan.f7.html';

import HelpDeskPage from '../pages/helpdesk.f7.html';
import NewCalendarPage from '../pages/newcalendar.f7.html';
import PlanNotAssigned from '../pages/plannot-assignedres.f7.html';
import Conversations from '../pages/conversations.f7.html';
import DashboardKeeperGrid from '../pages/dashboardKeeperGrid.f7.html';

var routes = [
    {
        path: '/main/',
        component: PmsPage,
        on: {
            pageBeforeIn: function (event, page) {
                if (localStorage.getItem('islogin') == null) {
                    app.f7.views.main.router.navigate('/login/', {
                        transition: 'f7-dive',
                    });
                    //actions.GetDetailsBeforePromise(this)
                    //.then(
                    //  function (result) {
                    //    alert(result); // Do anything.
                    //  }
                    //);

                    // actions.GetData(this);
                }
                let login = JSON.parse(localStorage.getItem('loginJson')) || '';
                if (login) {
                    if (login.IsHousekeeper === true) {
                        app.f7.views.main.router.navigate('/dashboardKeeper/', {
                            transition: 'f7-dive',
                        });
                    }
                }
            },
            pageAfterIn: function (event, page) {
                console.log('after-main');
            },
            pageInit: function (event, page) {
                console.log('init-main');
            },
            pageBeforeRemove: function (event, page) {
                // do something before page gets removed from DOM
            },
        },
        // Pass "tabs" property to route
        tabs: [
            // First (default) tab has the same url as the page itself
            {
                path: '/',
                id: 'dashboard',
                component: DashboardPage,
            },
            {
                path: '/reservations/',
                id: 'reservations',
                component: ReservationsCalendarPage,
                on: {
                    tabInit: function (event, page) {
                        console.log('tab-init');
                    },
                    tabReInit: function (event, page) {
                        console.log('tab-reinit');
                    },
                },
            },
            {
                path: '/reservations/date/:date',
                id: 'reservations',
                component: ReservationsCalendarPage,
                on: {
                    tabInit: function (event, page) {
                        console.log('tab-init');
                    },
                    tabReInit: function (event, page) {
                        console.log('tab-reinit');
                    },
                },
            },
            {
                path: '/reservationscalendar/',
                id: 'reservationscalendar',
                component: ReservationsCalendar,
            },
            // {

            //   path: "/reservations-calendar/",
            //   id: "reservationscalendar",
            //   component: ActivitiesPage,
            // },
            {
                path: '/availabilities/',
                id: 'availabilities',
                component: AvailabilitiesPage,
            },
            {
                path: '/NewCalendar/',
                component: NewCalendarPage,
                id: 'reservationscalendar',
            },
        ],
    },
    {
        path: '/popup-settings/',
        popup: {
            // content: `
            //   <div class="popup">
            //     <div class="view">
            //       <div class="page">
            //         ...
            //       </div>
            //     </div>
            //   </div>
            // `
            component: ActivitySettingsPage,
        },
    },
    // {
    //   path: "/",
    //   id: "SplashPage",
    //   component: SplashPage,
    // },
    {
        path: '/notifications/',
        component: NotificationsPage,
    },
    {
        path: '/test/',
        component: Test,
    },
    {
        path: '/settings/',
        component: SettingsPage,
    },
    {
        path: '/settings/',
        component: SettingsPage,
    },
    {
        path: '/invoices/',
        component: InvoicesPage,
    },
    {
        path: '/settingsnotifications/',
        component: SettingsNotifiationsPage,
    },
    {
        path: '/settingsdnd/',
        component: DoNotDisturbPage,
    },
    {
        path: '/settingsplan/',
        component: SettingPlan,
    },
    {
        path: '/arrivals-list/',
        component: ArrivalsList,
    },
    {
        path: '/departures-list/',
        component: DeparturesList,
    },
    {
        path: '/helpdesk/',
        id: 'helpdesk',
        component: HelpDeskPage,
    },
    {
        path: '/inhouse-list/',
        component: InhouseList,
    },
    {
        path: '/login/',
        component: LoginPage,
        on: {},
        options: {
            history: false,
            pushState: false,
        },
    },
    {
        path: '/forgot-password/',
        component: ForgotPasswordPage,
        on: {},
    },
    {
        path: '/test-settings/',
        component: ActivitySettingsPage,
    },
    // {
    //   path: '/reservationscalendar/',
    //   component: ReservationsCalendar,
    // },
    {
        path: '/room-status/',
        component: RoomStatusPage,
    },
    //new reservation
    {
        path: '/new-reservation-home/',
        //path: '/new-reservation-form/',
        component: NewReservationPage,
    },
    //reservation-info
    {
        path: '/reservation-info/',
        component: ReservationsInfo,
    },
    {
        path: '/search-reservation/',
        component: SelectedReservation,
    },
    {
        path: '/search-user/',
        component: SearchUser,
    },
    {
        path: '/block-info/:BlockID',
        component: BlockInfo,
    },
    {
        path: '/search-arrivals/',
        component: SearchArrivals,
    },
    {
        path: '/search-departures/',
        component: SearchDepartures,
    },
    {
        path: '/search-inhouse/',
        component: SearchInHouse,
    },
    {
        name: 'reservation-info',
        path: '/reservation-info/id/:id/',
        component: ReservationsInfo,
        // url: 'reservation-info.html?id={{id}}',
    },
    {
        path: '/availabilities/',
        id: 'availabilities',
        component: AvailabilitiesPage,
    },
    {
        path: '/reservationscalendar/',
        id: 'reservationscalendar',
        component: ReservationsCalendar,
    },
    //new reservation stay-details
    {
        path: '/new-reservation-staydetails/',
        component: NewReservationStayDetailsPage,
    },
    //new reservation complete
    {
        path: '/new-reservation-complete/',
        component: NewReservationCompletePage,
    },
    {
        path: '/setup-room-availability/',
        component: SetupRoomAvailabilityPage,
    },
    {
        path: '/price-and-limits/',
        component: PriceAndLimitsPage,
    },
    {
        path: '/test-settings/',
        component: ActivitySettingsPage,
    },
    {
        path: '/home/',
        component: HomePage,
    },
    {
        path: '/dashboard2/',
        component: DashboardPage,
    },
    {
        path: '/dashboardKeeper/',
        component: DashboardPageKeeper,
    },
    {
        path: '/about/',
        component: AboutPage,
    },
    {
        path: '/form/',
        component: FormPage,
    },
    {
        path: '/catalog/',
        component: CatalogPage,
        on: {
            pageBeforeIn: function (event, page) {
                console.log('before-catalog');
            },
            pageAfterIn: function (event, page) {
                console.log('after-catalog');
            },
            pageInit: function (event, page) {
                console.log('init-catalog');
            },
            pageBeforeRemove: function (event, page) {
                // do something before page gets removed from DOM
            },
        },
    },
    {
        path: '/product/:id/',
        component: ProductPage,
    },
    {
        path: '/settings/',
        component: SettingsPage,
    },
    {
        path: '/communicator/',
        component: Communicator,
    },
    {
        path: '/conversations/',
        component: Conversations,
    },
    {
        path: '/dashboardKeeperGrid/',
        component: DashboardKeeperGrid,
    },
    {
        path: '/plannotassigned',
        component: PlanNotAssigned,
    },
    {
        path: '/dynamic-route/blog/:blogId/post/:postId/',
        component: DynamicRoutePage,
    },
    {
        path: '/request-and-load/user/:userId/',
        async: function (routeTo, routeFrom, resolve, reject) {
            // Router instance
            var router = this;

            // App instance
            var app = router.app;

            // Show Preloader
            app.preloader.show();

            // User ID from request
            var userId = routeTo.params.userId;

            // Simulate Ajax Request
            setTimeout(function () {
                // We got user data from request
                var user = {
                    firstName: 'Vladimir',
                    lastName: 'Kharlampidi',
                    about: 'Hello, i am creator of Framework7! Hope you like it!',
                    links: [
                        {
                            title: 'Framework7 Website',
                            url: 'http://framework7.io',
                        },
                        {
                            title: 'Framework7 Forum',
                            url: 'http://forum.framework7.io',
                        },
                    ],
                };
                // Hide Preloader
                app.preloader.hide();

                // Resolve route to load page
                resolve(
                    {
                        component: RequestAndLoad,
                    },
                    {
                        context: {
                            user: user,
                        },
                    }
                );
            }, 1000);
        },
    },
    {
        path: '(.*)',
        component: NotFoundPage,
    },
];

export default routes;
